import { render, staticRenderFns } from "./InterActiveReaders.vue?vue&type=template&id=5e7b3056&scoped=true&"
import script from "./InterActiveReaders.vue?vue&type=script&lang=js&"
export * from "./InterActiveReaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7b3056",
  null
  
)

export default component.exports